import { useState } from "react";
import styles from "./styles.module.scss";
import { useClickOutSide } from "../../../hooks/useClickOutside";
import { AngleDown } from "../../../assets/svgIcons";

const TwoStepSelectField = ({
  options = [],
  subKey = "sub_account_types",
  idKey = "value",
  nameKey = "label",
  value = null,
  onChange = () => {},
  placeholder = "Select an option",
  label = null,
  labelDescription = null,
  isRequired = false,
  isDisabled = false,
  errorMessage = undefined,
  floatError = true,
  classNames = "",
  name = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { inputRef } = useClickOutSide({ close: () => setIsOpen(false) });

  const selectedLabel = (() => {
    for (const group of options) {
      const sub = group[subKey]?.find((item) => item[idKey] === value);
      if (sub) return sub[nameKey];
    }
    return null;
  })();

  return (
    <span className={`${styles.twoStepSelect} ${classNames}`} ref={inputRef}>
      {label !== null && (
        <>
          <label htmlFor={name} data-testid="label">
            {isRequired && <span className="text-danger">*</span>}
            <span>{label}</span>
          </label>
          {labelDescription ? (
            <span className="d-block gray--text smallest-text-size mb-1">
              {labelDescription}
            </span>
          ) : null}
        </>
      )}

      <span
        className={`${styles.trigger} ${isDisabled ? styles.disabled : ""} ${
          errorMessage !== undefined ? styles.hasError : ""
        }`}
        onClick={() => {
          if (isDisabled) return;
          setIsOpen((prev) => !prev);
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            if (isDisabled) return;
            setIsOpen((prev) => !prev);
          }
        }}
      >
        <span
          className={`${styles.triggerText} ${!selectedLabel && !value ? styles.placeholder : ""}`}
        >
          {selectedLabel || value || placeholder}
        </span>
        <AngleDown
          className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ""}`}
          style={{ color: "#cccccc" }}
        />
      </span>

      {errorMessage !== undefined && (
        <span
          className={`error-message ${!floatError ? "show" : ""} smallest-text-size`}
          style={{
            visibility: errorMessage ? "visible" : "hidden",
            display: "flex",
            marginTop: "2px",
            minHeight: "15px",
            fontSize: "13px",
            color: "#dc3545",
          }}
        >
          {errorMessage?.message || errorMessage}
        </span>
      )}

      <span className={`${styles.dropdown} ${isOpen ? styles.active : ""}`}>
        {options.length ? (
          options.map((group) => (
            <span key={group[idKey]} className={styles.group}>
              <span className={styles.groupHeader}>{group[nameKey]}</span>
              {group[subKey]?.map((item) => (
                <span
                  key={item[idKey]}
                  className={`${styles.option} ${
                    value === item[idKey] ? styles.selected : ""
                  }`}
                  role="option"
                  aria-selected={value === item[idKey]}
                  onClick={() => {
                    onChange(item[idKey], item[nameKey], item);
                    setIsOpen(false);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onChange(item[idKey], item[nameKey], item);
                      setIsOpen(false);
                    }
                  }}
                  tabIndex={0}
                >
                  {item[nameKey]}
                </span>
              ))}
            </span>
          ))
        ) : (
          <span className="text-center d-block my-3 smallest-text-size">
            No options available
          </span>
        )}
      </span>
    </span>
  );
};

export default TwoStepSelectField;
